import { attr } from 'spraypaint';
import ApplicationRecord from './ApplicationRecord';

const Transaction = ApplicationRecord.extend({
  attrs: {
    amount: attr(),
    card_payment: attr(),
    card_token: attr(),
    credit_deduction: attr(),
    customer_id: attr(),
    description: attr(),
    discount: attr(),
    external_payload: attr(),
    forced_credit: attr(),
    metadata: attr(),
    purchase_id: attr(),
    recuperated: attr(),
    delivery_id: attr(),
    threeds_redirect_url: attr(),
    status: attr({ type: String }),
    checkout_status: attr({ type: String }),
    checkout_response_code: attr({ type: String }),
    checkout_response_summary: attr({ type: String }),
    checkout_error_code: attr({ type: String }),
    checkout_3ds_authentication_response: attr({ type: String }),
    error_message: attr({ type: String }),
  },
  static: {
    endpoint: '/transactions',
    jsonapiType: 'payments-transactions',
  },
});

export default Transaction;
